"use strict";
// Class definition

var PortalHtmlTable = function() {
	// Private functions

	// Initializer
	var setup = function() {
	  // Fundings index
	  if ($('#fundings').length) {
	    var datatable = $('#fundings').KTDatatable({
	    	toolbar: {
	    		items: {
	    			pagination: {
      				pageSizeSelect: [10, 25, 50, 100],
	    			}
	    		}
	    	},
	    	data: {
	    		pageSize: 10,
	    	},

	      search: {
	        input: $('#kt_search'),
	      },
	      columns: [
					{
						field: 'Max Amount',
						sortCallback: (data, sort, column) => {
					    var field = column['field'];

					    return data.sort((a, b) => {
				        var aField = parseFloat(a[field].replaceAll(',', '')) || 0;
				        var bField = parseFloat(b[field].replaceAll(',', '')) || 0;

				        if (sort === 'asc') {
			            return aField > bField
			                ? 1 : aField < bField
			                    ? -1
			                    : 0;
				        } else {
			            return aField < bField
			                ? 1 : aField > bField
			                    ? -1
			                    : 0;
				        }
					    });
						}
					},
					{
						field: 'Apply here',
						sortable: false,
					}
				]
	    });

	    $('#kt_form_category').on('change', function() {
	      datatable.search($(this).val(), 'Category');
	    });

	    // $('#kt_form_applied_to').on('change', function() {
	    //   datatable.search($(this).val(), 'Applicant type');
	    // });

	    // Hide category and applicant type columns
	    datatable.column(7).visible(false);
	    // datatable.column(8).visible(false);
	  }

	  // Admin user management
	  // if ($('#admin_users').length) {
	  //   var datatable = $('#admin_users').KTDatatable({
	  //     search: {
	  //       input: $('#kt_search'),
	  //     },

	  //     columns: [
			// 		{
			// 			field: 'User created',
			// 			type: 'date',
			// 			format: 'DD.MM.YYYY h:mm:ss',
			// 		},
			// 		{
			// 			field: 'Last seen',
			// 			type: 'date',
			// 			format: 'DD.MM.YYYY h:mm:ss',
			// 		},
			// 		{
			// 			field: 'Expired date',
			// 			type: 'date',
			// 			format: 'DD.MM.YYYY',
			// 		},
			// 		{
			// 			field: 'Paid date',
			// 			type: 'date',
			// 			format: 'DD.MM.YYYY',
			// 		}
   //      ]
	  //   });
	  // }

	  // Admin analytics
	  if ($('#inactive_profiles_activity_data_table').length) {
	    var datatable = $('#inactive_profiles_activity_data_table').KTDatatable({
	    	toolbar: {
	    		items: {
	    			pagination: {
      				pageSizeSelect: [10, 25, 50, 100],
	    			}
	    		}
	    	},
	    	data: {
	    		pageSize: 10,
	    	},

	    	columns: [
					{
						field: 'Registration date',
						type: 'date',
						format: 'DD.MM.YYYY h:mm:ss',
					},
				]

	      // search: {
	      //   input: $('#inactive_profiles_activity_data_table_search'),
	      // },
	    });
	  }
	};

	return {
		// Public functions
		init: function() {
			// init
			setup();
		},
	};
}();

jQuery(document).ready(function() {
	PortalHtmlTable.init();
});
